// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../Kontent/Kontent.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as FaArrowRight from "@fortawesome/pro-regular-svg-icons/faArrowRight";

var arrowRight = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color("transparent"),
      BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
      BsCssJs$PrezzeeRibbon.transitionProperty("color")
    ]);

var iconLine = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.cursor("pointer"),
      BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.px(12), BsCssJs$PrezzeeRibbon.px(14)),
      BsCssJs$PrezzeeRibbon.borderRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius),
      BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
      BsCssJs$PrezzeeRibbon.transitionProperty("background-color, color"),
      BsCssJs$PrezzeeRibbon.hover([
            BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.paleGrey),
            BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.activeBlue),
            BsCssJs$PrezzeeRibbon.selector("." + arrowRight, [BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.activeBlue)])
          ])
    ]);

var menuIcon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(18)),
      BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.rem(10)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center")
    ]);

var childrenWrapper = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.flexGrow(1)]);

var Styles = {
  arrowRight: arrowRight,
  iconLine: iconLine,
  menuIcon: menuIcon,
  childrenWrapper: childrenWrapper
};

function ProfileMenu__Line(props) {
  var arrowRight$1 = JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
        icon: FaArrowRight.faArrowRight
      });
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: props.icon,
                            className: menuIcon
                          }),
                      JsxRuntime.jsx("div", {
                            children: props.children,
                            className: childrenWrapper
                          }),
                      JsxRuntime.jsx("div", {
                            children: arrowRight$1,
                            className: arrowRight
                          })
                    ],
                    className: iconLine,
                    onClick: props.onClick
                  })
            });
}

var make = ProfileMenu__Line;

export {
  Styles ,
  make ,
}
/* arrowRight Not a pure module */
